export default {
    meta: {
        title: '数据服务',
    },
};
